export const isEmptyObject = obj => JSON.stringify(obj) === '{}';

/**
 * Tab setup expects a URL in `iframeLink`, but admins often paste a full
 * `<iframe src="...">` snippet. Browsers cannot load that string as `src`
 * (you get about:blank). Extract `src` when the value looks like iframe HTML.
 */
export function normalizeIframeSrc(input) {
  if (!input || typeof input !== 'string') return ''
  const trimmed = input.trim()
  if (!trimmed) return ''
  if (!/<iframe/i.test(trimmed)) return trimmed
  // Double/single quotes and common “smart” quotes from paste
  const quoted = trimmed.match(
    /src\s*=\s*["'“”‘’]([^"'“”‘’]+)["'“”‘’]/i
  )
  if (quoted) return quoted[1].trim()
  const unquoted = trimmed.match(/src\s*=\s*([^\s>]+)/i)
  if (unquoted) return unquoted[1].trim()
  return trimmed
}
